@if (isHuge){
<div class="flex flex-middle flex-justify-between">
    <div>
        <span class="s2">{{'Colour' | translate }}: </span>
        <span class="p2">@if (product.data.parent && product.data.variant_attribute_1) {
            {{product.variantAttribute1}}
            }
            @if (!product.data.parent && product.data.web_finish) {
            {{product.data.web_finish}}
            }</span>
    </div>
    @if(!upsellVariant){
    <product-view-samples *ifSize="'!S'"
                          [product]="product"
                          class="block"></product-view-samples>
    }

</div>
}
<swatch [attributeCode]="'config_colour'"
        [value]="product?.data?.config_colour"
        class="inline-block va-m m-r-2 m-t-3"
        [isHuge]="isHuge"
        [isRound]="true"
        [selected]="true"
        [disabled]="false"></swatch>
@for (crossSellProduct of options; track trackByProductId($index, crossSellProduct)) {
<div class="inline-block va-m m-r-2 m-t-3 cursor-pointer"
     (click)="productClick.next(crossSellProduct)">
    <href [link]="!upsellVariant && crossSellProduct.data.url">
        <swatch [isHuge]="isHuge"
                [isRound]="true"
                [attributeCode]="'config_colour'"
                [value]="crossSellProduct.data.config_colour"
                [selected]="false"
                [disabled]="false"></swatch>
    </href>
</div>

}
